/**
 * i18n extensions
 * ----------------
 * Every *.js file in this folder (except index.js) is auto-loaded and merged
 * into the main translations table in LanguageContext.jsx.
 *
 * Each file must `export default { en: {...}, tr: {...}, es: {...} }`.
 * Keys defined here OVERRIDE keys with the same name in LanguageContext.
 * Always provide at least en + tr + es for every key.
 *
 * Use one file per feature area (e.g. dashboard.js, admin.js) so that
 * parallel work never touches the same file.
 */
const ctx = require.context("./", false, /^\.\/(?!index\.js$)[\w-]+\.js$/);

const extensions = ctx.keys().map((k) => ctx(k).default || {});

export function mergeExtensions(translations) {
  for (const ext of extensions) {
    for (const lang of Object.keys(ext)) {
      translations[lang] = Object.assign(translations[lang] || {}, ext[lang]);
    }
  }
  return translations;
}

export default extensions;
